import React, { useEffect } from "react";
import { Box, Skeleton, Typography, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import {
  getSettingState,
  setCustomModal,
} from "../../../redux/features/settingSlice";
import RightLeftChecker from "../../../utils/RightLeftChecker";

const CustomModal = ({ children, count, subject, closeCallback }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { customModal, modalTitle } = useSelector(getSettingState);
  const location = useLocation();
  const navigate = useNavigate();

  const backBtn = () => {
    window.onpopstate = function () {
      dispatch(setCustomModal(false));
    };
  };
  customModal && backBtn();

  const handleCloseModal = () => {
    dispatch(setCustomModal(false));
    closeCallback && closeCallback();
  };

  const variants = {
    open: {
      top: count >= 7 || count === 0 ? "0px" : "auto",
    },
    closed: {
      top: "130vh",
    },
  };

  useEffect(() => {
    if (customModal) {
      navigate(location.pathname + "?modal=1");
    } else {
      navigate(location.pathname, { replace: true });
    }
  }, [customModal, location.pathname, navigate]);

  return (
    <>
      {customModal && (
        <motion.div
          onClick={handleCloseModal}
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.5 }}
          style={{
            backgroundColor: theme.palette.black.main,
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            zIndex: 3,
          }}
        ></motion.div>
      )}
      <motion.div
        variants={variants}
        animate={customModal ? "open" : "closed"}
        initial={{ top: customModal ? "auto" : "130vh" }}
        transition={{
          default: { ease: "linear" },
        }}
        style={{
          display: "flex",
          flexDirection: "column",
          border: "2px solid",
          borderColor: "black.main",
          borderRadius: "16px 16px 0px 0px",
          position: "absolute",
          backgroundColor: theme.palette.white.main,
          bottom: "0",
          width: "100%",
          maxWidth: "450px",
          zIndex: 5,
        }}
      >
        <Box
          sx={{
            height: !modalTitle ? "58px" : "82px",
            display: "flex",
            justifyContent: "space-between",
            padding: "8px 16px 12px 16px",
            borderBottom: "2px solid",
            borderColor: "black.main",
          }}
        >
          <Box sx={{ width: "90%" }}>
            {modalTitle && (
              <Typography
                noWrap
                sx={{
                  fontSize: "16px",
                  fontWeight: "400",
                  lineHeight: "1.8",
                  pt: "3px",
                  textAlign: "left",
                  direction: RightLeftChecker(modalTitle) ? "rtl" : "ltr",
                }}
              >
                {modalTitle}
              </Typography>
            )}

            <Typography
              noWrap
              sx={{
                fontSize: "24px",
                fontWeight: "600",
                lineHeight: "1.8",
                textAlign: "left",
                direction: RightLeftChecker(subject) ? "rtl" : "ltr",
              }}
            >
              {subject ? subject : <Skeleton width={250} height={36} />}
            </Typography>
          </Box>

          <Box
            onClick={handleCloseModal}
            sx={{
              display: "flex",
              alignItems: "start",
              cursor: "pointer",
              pt: "5px",
            }}
          >
            <CloseRoundedIcon />
          </Box>
        </Box>
        <Box
          sx={{
            padding: "24px 16px 0 16px",
            overflowY: "scroll",
          }}
        >
          {children}
        </Box>
      </motion.div>
    </>
  );
};

export default CustomModal;
